import { Box, Divider } from "@mui/joy";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

import { useProject } from "../../../../hooks/query";
import { IProjectList } from "../../../../interfaces";

import { Title } from "./Title";
import { StatusGraph } from "./StatusGraph";
import { ProjectListSkeleton } from "./Skeleton";
import { Alert } from "../../../../shared";
import { DataGrid } from "../../..";

import { columnDef } from "./column-def";

export default function ListProject() {
    const { useList } = useProject();
    const projectListSvc = useList();
    const navigate = useNavigate();

    const [projects, setProjects] = useState<IProjectList[]>([]);

    const fetchData = async () => {
        try {
            const response = await projectListSvc.mutateAsync();
            setProjects(response);
        } catch (e) {
            console.error("Error fetching data", e);
        }
    };

    const handleRowClicked = (event: any) => {
        navigate(`/project/list/${event.data.Id}`);
    };

    useEffect(() => {
        fetchData().then();
    }, []);

    const isLoading = projectListSvc.isPending && projects.length === 0;

    return (
        <Box flex={1} display={"flex"} flexDirection={"column"} position={"relative"}>
            <AnimatePresence mode="wait">
                {isLoading ? (
                    <motion.div
                        key="skeleton"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        style={{ width: "100%", flex: 1, display: "flex", flexDirection: "column" }}
                    >
                        <ProjectListSkeleton />
                    </motion.div>
                ) : (
                    <motion.div
                        key="content"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.4 }}
                        style={{ width: "100%", flex: 1, display: "flex", flexDirection: "column" }}
                    >
                        <Box mx={3} mt={3}>
                            <Title onRefreshClick={fetchData} svc={projectListSvc} />
                        </Box>

                        {projectListSvc.error && (
                            <Box m={3}>
                                <Alert errorMessage={projectListSvc.error} />
                            </Box>
                        )}

                        <Divider sx={{ mt: 3 }} />
                        <Box mx={3} mt={3}>
                            <StatusGraph />
                        </Box>
                        <Divider sx={{ mt: 2 }} />
                        <Box flex={1}>
                            {projects.length > 0 && (
                                <DataGrid
                                    gridData={projects}
                                    columnDefs={columnDef}
                                    hideHeader={true}
                                    suppressCellFocus={true}
                                    onRowClicked={handleRowClicked}
                                    rowHeight={70}
                                    rowStyle={{
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                        </Box>
                    </motion.div>
                )}
            </AnimatePresence>
        </Box>
    );
}
